import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

// Images

import SubjectBoxLayers from "../../Assets/Images/LandingPage/subjects_box_vector.svg";

export const SubscriptionPlansContainer = styled.div`

    .plans_section {
        background: #fff;
        padding: 100px 0;
        .plans-section-head {
            max-width: 1020px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 40px;
            p{
                margin-top:10px;
            }
        }
        .plans_info_wrapper{
            justify-content:center;
        }
        .plans-section-head {
            text-align: center;
        }
        .subjects_info-box-col{
            padding-top: 15px;
            padding-bottom: 15px;
        }
        .subjects_info-box {
            border-radius: 0 50px;
            text-align: center;
            perspective: 1000px;
            min-height: 380px; 
            height: 100%;
            cursor:pointer;
        }

        .card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            transition: transform 0.8s ease;
            transform-style: preserve-3d;
            z-index:1;
            &:after{
                position: absolute;
                content: "";
                background: url(${SubjectBoxLayers}) no-repeat;
                width: 100%;
                height: 100%;
                bottom: 0;
                right: 0;
                background-position: bottom right;
                background-size: 250px;
            }
        }

    }

     @media (max-width: 1199px) {
        .plans_section {
            padding: 70px 0;
            padding-bottom: 45px;
        }     
    }

    @media (max-width: 991px) {
        h2.head_wid_icon:after {
            display:none;
        }
    }
    @media (max-width: 767px) {
        .plans_section {
            padding: 50px 0;
            padding-bottom: 45px;
        }
    }




`;